import React from 'react'
import DOMPurify from 'dompurify'
let ErrorTextBlock = ({className, title, text}) =>
    <div className={`${className} text-danger`}>
        <div>
            <small>
                <strong>{title}</strong>
            </small>
        </div>
        <div>
            <small dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text)}}>
            </small>
        </div>
    </div>

export default ErrorTextBlock



// WEBPACK FOOTER //
// ./src/components/ui/ErrorTextBlock.js